<template>
  <div class="yhc-es-form--config-controls-for-preview">
    <div class="card m-2">
      <div class="card-header bg-white">プレビュー条件の設定</div>
      <div class="card-body">
        <ModelForm
          :columns="{
            isDebugMode: {
              label: '開発モードとして表示',
              type: 'BOOLEAN',
              inputHelpText:
                '家財種別マスタ などで デバッグ用のデータを表示する場合に使用します。',
            },
            specifyBaseDatetime: {
              label: '基準日時を指定する',
              type: 'BOOLEAN',
              inputHelpText: '指定しない場合は、現在時刻が基準となります。',
            },
            baseDatetime: {
              label: '基準日時',
              type: 'DATETIME',
              validate: { notEmpty: true },
              enableIf: (row) => row.specifyBaseDatetime === true,
            },
          }"
          :record="record"
          :on-submit-function="(data) => reloadPage(data)"
          :submit-button-label="'上記条件でプレビュー表示'"
          :disable-confirm-before-submit="true"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { YhcEstimateFormFrontService } from '../YhcEstimateFormFrontService'

/**
 * Preview 用途でのみ表示するコンポーネント
 * 管理画面からLoadする場合にのみ有効化, Front form では表示しない
 *
 * ## 責任範囲
 * - 開発モードの on/off 切り替え
 * - 基準となる 日時 (baseDatetime) の再設定
 * - 再読み込みのボタンの提供 & Kick
 *
 */
export default {
  name: 'YhcEFConfigControlsForPreview',
  data() {
    return {
      record: {
        isDebugMode: false,
        baseDatetime: this.getNowDatetime(),
        specifyBaseDatetime: false,
      },
    }
  },
  inject: ['YhcEstimateFormFrontServiceInstance'],
  computed: {
    $yhcefs(): YhcEstimateFormFrontService {
      return this.YhcEstimateFormFrontServiceInstance
    },
  },
  methods: {
    async reloadPage(data) {
      if (data.specifyBaseDatetime && !data.baseDatetime) {
        return // do nothing
      }
      this.$yhcefs.baseDatetime = data.specifyBaseDatetime
        ? data.baseDatetime
        : this.getNowDatetime()
      this.$yhcefs.isDebugMode = data.isDebugMode
      this.$parent.init()
    },
    getNowDatetime() {
      return $core.$dayjs().format('YYYY-MM-DD HH:mm:ss')
    },
  },
}
</script>
